import { type Components } from '@mui/material';
import { HorizonTheme } from './horizon-theme';

export const muiDialog: Components<HorizonTheme>['MuiDialog'] = {
  defaultProps: {
    fullWidth: true,
    maxWidth: 'sm',
    scroll: 'body',
    PaperProps: {
      elevation: 0,
    },
  },
  styleOverrides: {
    paper: {
      borderRadius: 12,
    },
    root: ({ theme }) => ({
      color: theme.palette.black.main,
    }),
  },
};
